import React from 'react';
import { emit } from '../Socket/game.Emitters';
import MessageList from './MessageList';
import { getPlayerConsoleIconPath } from '../../env'

import { gameStateManager } from '../../App';

class ChatBox extends React.Component
{

  state = {
    inputTextValue: "",
    messages: []
  };

  constructor( props )
  {
    super( props );

    this.myRef = React.createRef();
  }

  componentDidMount()
  {
    gameStateManager.addOnRoomChatMessageCallback( this.onRoomChatMessageCallback );
  }

  componentWillUnmount()
  {
    gameStateManager.removeOnRoomChatMessageCallback( this.onRoomChatMessageCallback );
  }

  onRoomChatMessageCallback = ( chatTextData ) =>
  {
    // {text: 'Good luck everyone!', playerIconID: 'default'}
    // {chatBotMessage: 'Please don't swear.'}

    // console.log('chatTextData', chatTextData);

    let messageData;

    if( chatTextData.chatBotMessage )
    {
      // Message from 'chat bot'
      messageData =
      {
        prefix: "ChatBot: ",
        text: chatTextData.chatBotMessage
      };
    }
    else
    {
      // Message from room player

      messageData = chatTextData;

      if( typeof messageData.playerIconID !== 'undefined' )
      {
        messageData.messageIconPath = getPlayerConsoleIconPath( messageData.playerIconID, messageData.teamColourID );

        delete messageData.playerIconID;
      }
    }

    this.setState( state => ( { messages: [ ...state.messages, messageData ] } ) );
  };

  onTextInputChange = ( e ) =>
  {
    let currentChatTextValue = e.target.value;

    if( currentChatTextValue.length > 200 )
    {
      // Cap the text input length at 200 characters max
      currentChatTextValue.length = 200;
    }

    this.setState( { inputTextValue: currentChatTextValue } );
  };

  handleChatTextSubmit = ( e ) =>
  {
    // Prevent the browser from reloading the page
    e.preventDefault();

    // Read the form data
    const form = e.target;
    const formData = new FormData( form );
    const submittedChatText = formData.get( 'chat-input-text' );

    // console.log( "submittedChatText : ", submittedChatText );

    emit.submitChatText( submittedChatText );

    // Clear current input text
    this.setState( { inputTextValue: "" } );
  };

  render()
  {
    const { messages } = this.state;
    const { className,
      messageListClassNamesPrefix,
      style } = this.props;

    let cssStyle = style != null ? style : {};

    return (
      <div
        className={ className }
        style={ cssStyle }
      >
        <MessageList
          classNamesPrefix={ messageListClassNamesPrefix }
          messages={ messages }
        />

        <form method="post" onSubmit={ this.handleChatTextSubmit } className={ messageListClassNamesPrefix + "-chatboxinputform" } style={ { display: 'flex' } }>
          <input
            autoComplete="off"
            type="text"
            placeholder="Send a message"
            name="chat-input-text"
            id="lobby_chat_input"
            maxLength="200"
            value={ this.state.inputTextValue }
            onChange={ this.onTextInputChange }
          />

          <button type="submit" id="lobby_chat_button">
            <img src={ process.env.PUBLIC_URL + '/ui/chat-send-icon.png' } alt="Send message button icon" />
          </button>
        </form>
      </div>
    );
  }
}

export default ChatBox;
